import { Podcast } from '@root/modules/podcast/types/podcast';

export const resort = (items: Podcast[], ids: string[]) => {
  const numericIds = ids.map((id) => Number(id));

  if (!numericIds.length) {
    return items;
  }

  return items.sort((a, b) => numericIds.indexOf(a.id) - numericIds.indexOf(b.id));
};

export default resort;
